module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo18-6a804260d012720701fd629d69690e9d.jpg";